export enum SnapKind {
  GRID = "GRID",
  VERTICAL = "VERTICAL",
  HORIZONTAL = "HORIZONTAL",
  VERTEX = "VERTEX",
  MID = "MID",
  NEAR = "NEAR",
  INTERSECT = "INTERSECT",
  PROJECT = "PROJECT",
}
